import { JsonObject } from 'json2typescript';
import { ProfileInterface } from '../interfaces/profile.interface';

@JsonObject('Profile')
export class Profile implements ProfileInterface {
  ProfileCode?: string;
  ProfileName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
